import { isVerticalWritingMode } from "./isVerticalWritingMode";

export const getScrollBarSize = () => {
  const scrollBarXSize = window.innerHeight - document.body.clientHeight;
  const scrollBarYSize = window.innerWidth - document.body.clientWidth;
  return isVerticalWritingMode() ? scrollBarXSize : scrollBarYSize;
};
